import React from 'react'
import styles from './styles.module.scss'
import { Link } from 'react-router-dom'
import logo from './../../../assets/images/footer_logo.png'
import { useLanguage } from '../../../context/LanguageContext'

export const Footer = () => {
    const { language } = useLanguage()

    const data = [
        {
            id: 'dsad2s',
            url: '/',
            title: {
                ka: 'მთავარი',
                en: 'Home',
                ru: 'ホーム'
            }
        },
        {
            id: 'fsa2fs',
            url: '/about',
            title: {
                ka: 'ასოციაცია',
                en: 'Association',
                ru: '協会'
            }
        },
        {
            id: 'fast33f',
            url: '/education',
            title: {
                ka: 'კურსები',
                en: 'Courses',
                ru: 'コース'
            }
        },
        {
            id: 'sdgf3gd',
            url: '/events',
            title: {
                ka: 'ღონისძიებები',
                en: 'Events',
                ru: 'イベント'
            }
        },
        {
            id: 'gs3d',
            url: '/contact',
            title: {
                ka: 'კონტაქტი',
                en: 'Contact',
                ru: 'お問い合わせ'
            }
        }
    ]

    return (
        <footer className={styles.footer}>
            <div className='container'>
                <div className='row'>
                    <div className='col-lg-6'>
                        <img src={logo} alt='logo' className={styles.footer__logo} />
                    </div>
                    <div className='col-lg-6 d-flex flex-column align-items-md-end'>
                        <ul className={`${styles.footer__menu} d-block d-md-flex `}>
                            {data?.map((item) => {
                                return (
                                    <li key={item.id}><Link to={item.url}>{item.title[language]}</Link></li>
                                )
                            })}
                        </ul>
                        <ul className={styles.footer__soc}>
                            <li>
                                <Link to={'https://www.facebook.com/InternationalGeorgianCalligraphyAssociation'} target='_blank'>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M160 96C124.7 96 96 124.7 96 160L96 480C96 515.3 124.7 544 160 544L258.2 544L258.2 398.2L205.4 398.2L205.4 320L258.2 320L258.2 286.3C258.2 199.2 297.6 158.8 383.2 158.8C399.4 158.8 427.4 162 438.9 165.2L438.9 236C432.9 235.4 422.4 235 409.3 235C367.3 235 351.1 250.9 351.1 292.2L351.1 320L434.7 320L420.3 398.2L351 398.2L351 544L480 544C515.3 544 544 515.3 544 480L544 160C544 124.7 515.3 96 480 96L160 96z" /></svg>
                                </Link>
                            </li>
                            <li>
                                <Link to={'https://www.instagram.com/georgian.calligraphy1'} target='_blank'>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M320.3 205C256.8 204.8 205.2 256.2 205 319.7C204.8 383.2 256.2 434.8 319.7 435C383.2 435.2 434.8 383.8 435 320.3C435.2 256.8 383.8 205.2 320.3 205zM319.7 245.4C360.9 245.2 394.4 278.5 394.6 319.7C394.8 360.9 361.5 394.4 320.3 394.6C279.1 394.8 245.6 361.5 245.4 320.3C245.2 279.1 278.5 245.6 319.7 245.4zM413.1 200.3C413.1 185.5 425.1 173.5 439.9 173.5C454.7 173.5 466.7 185.5 466.7 200.3C466.7 215.1 454.7 227.1 439.9 227.1C425.1 227.1 413.1 215.1 413.1 200.3zM542.8 227.5C541.1 191.6 532.9 159.8 506.6 133.6C480.4 107.4 448.6 99.2 412.7 97.4C375.7 95.3 264.8 95.3 227.8 97.4C192 99.1 160.2 107.3 133.9 133.5C107.6 159.7 99.5 191.5 97.7 227.4C95.6 264.4 95.6 375.3 97.7 412.3C99.4 448.2 107.6 480 133.9 506.2C160.2 532.4 191.9 540.6 227.8 542.4C264.8 544.5 375.7 544.5 412.7 542.4C448.6 540.7 480.4 532.5 506.6 506.2C532.8 480 541 448.2 542.8 412.3C544.9 375.3 544.9 264.5 542.8 227.5zM495 452C487.2 471.6 472.1 486.7 452.4 494.6C422.9 506.3 352.9 503.6 320.3 503.6C287.7 503.6 217.6 506.2 188.2 494.6C168.6 486.8 153.5 471.7 145.6 452C133.9 422.5 136.6 352.5 136.6 319.9C136.6 287.3 134 217.2 145.6 187.8C153.4 168.2 168.5 153.1 188.2 145.2C217.7 133.5 287.7 136.2 320.3 136.2C352.9 136.2 423 133.6 452.4 145.2C472 153 487.1 168.1 495 187.8C506.7 217.3 504 287.3 504 319.9C504 352.5 506.7 422.6 495 452z" /></svg>
                                </Link>
                            </li>
                            <li>
                                <Link to={'https://youtube.com/@dabrunebatheater'} target='_blank'>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M581.7 188.1C575.5 164.4 556.9 145.8 533.4 139.5C490.9 128 320.1 128 320.1 128C320.1 128 149.3 128 106.7 139.5C83.2 145.8 64.7 164.4 58.4 188.1C47 231 47 320.4 47 320.4C47 320.4 47 409.8 58.4 452.7C64.7 476.3 83.2 494.2 106.7 500.5C149.3 512 320.1 512 320.1 512C320.1 512 490.9 512 533.5 500.5C557 494.2 575.5 476.3 581.8 452.7C593.2 409.8 593.2 320.4 593.2 320.4C593.2 320.4 593.2 231 581.8 188.1zM264.2 401.6L264.2 239.2L406.9 320.4L264.2 401.6z" /></svg>
                                </Link>
                            </li>
                            <li>
                                <Link to={'https://linktr.ee/tikasvanidzevancko'} target='_blank'>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M112 237.4L237.8 237.4L148.4 152L197.9 101L283.1 188.8L283.1 64L357 64L357 188.8L442.2 101.2L491.6 152L402.2 237.2L527.9 237.2L527.9 307.7L401.5 307.7L491.5 395.3L442.2 445.1L320 322.1L197.8 445.1L148.3 395.5L238.3 307.9L111.9 307.9L111.9 237.4zM282.9 408.8L356.8 408.8L356.8 576L282.9 576L282.9 408.8z" /></svg>
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </footer >
    )
}
